import React, { useEffect, useState, useRef } from "react";
import { Table, Input } from "antd";
// import { getApmcApplicationDetails, getApplications, getPanelApplications } from "../../auth/services/privateapicalling";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
// import { label } from "yet-another-react-lightbox/*";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
// import { Ellipsis } from "react-bootstrap/esm/PageItem";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from "react-toastify";
import { getAggreementDetails } from "../../../auth/services/apiCalling"
import { all_routes } from "../../../router/all_routes";
import Select from 'react-select';
import { label } from "yet-another-react-lightbox/*";


const SponsorDashboard: React.FC = () => {
  const language = useSelector((state: any) => state.auth.language);
  const token = useSelector((state: any) => state.auth.token);
  const navigate = useNavigate();

  const [totalRec, setTotalRec] = useState(1000000000); // Default size
  const [selectPending, setSelectPending] = useState<any>({ value: 'all', label: 'All Applications' });
  const [loading, setLoading] = useState(false);
  const userDetail = useSelector((state: any) => state.auth.userDetails);
  const roleIdentifier = userDetail?.Role?.Role_Identifier;
  // const [appStatus, setAppStatus] = useState({label: '', value: ''});
  const routes = all_routes;

  const [aggreementdetails, setAggreementdetails] = useState<any>();

  const handleRedirect = () => {
    navigate("/sponsor-agreement");
  };

  const fetchAggreementDetails = async (selectPending: any) => {
    setLoading(true)
    try {
      const ress = await getAggreementDetails(token, selectPending?.value, totalRec);
      if (ress?.success) {
        setAggreementdetails(ress?.data);
       
      } else {
        toast.error(ress?.message, { position: "top-right" });
      }
    } catch (ee) {
      toast.error(ee, { position: "top-right" });
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    if (roleIdentifier === "SPO") {
      fetchAggreementDetails(selectPending);
    }

  }, [roleIdentifier, selectPending])



  const tableData = aggreementdetails
    ?.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
    .map((dt: any, ind: any) => ({
      key: ind + 1,
      Sponsor_Id: dt?.applicationId,
      Applied_Date: dt?.createdAt,
      Status: dt?.status,
      appStatusLevel: dt?.appStatusLevel
    }));



  const options = [
    { value: 'all', label: 'All Applications' },
    { value: 'forwardToSponsorAterApproval', label: 'Pending at Sponsor' },
    { value: 'pendingAtMBA', label: 'Pending At Marketing Board Administrator' },
    { value: 'pendingAtMBMD', label: 'Pending At Marketing Board Managing Director' },
    { value: 'forwardToMBAAterApproval', label: 'Doc Review Pending at Board Managing Administrator' },
    { value: 'forwardToMBMDAterApproval', label: 'Doc Review Pending at Board Managing Director' }
  ];
  const handleChange = (selectedOption: any) => {

    setSelectPending(selectedOption)
  };

  const handleViewCertificate = (record: any) => {
    navigate(routes.certificateMD, { state: record });
  }

  const handleRoute = (Sponsor_Id: any) => {
    if (Sponsor_Id?.appStatusLevel === "pendingAtMBA") {
      navigate(routes.mbAgreement, { state: Sponsor_Id });
    } else if (Sponsor_Id?.appStatusLevel === "forwardToSponsorAterApproval" || Sponsor_Id?.appStatusLevel === "forwardToSpoAfterApprovalResubmissionn") {
      navigate(routes.stampPaperSponsor, { state: Sponsor_Id });
    } else if (Sponsor_Id?.appStatusLevel === "fillFormJResubmission") {
      navigate(routes.mbAgreement, { state: Sponsor_Id });
    } else if (Sponsor_Id?.Status === "pending" || Sponsor_Id?.appStatusLevel == "forwardToMBAAterApproval" || Sponsor_Id?.appStatusLevel == "pendingAtMBMDResubmission") {
      navigate(routes.mbAgreement, { state: Sponsor_Id });
    } else {
      navigate(routes.mbAgreement, { state: Sponsor_Id });
    }
  }
  const columns = [
    {
      title: "Sr N.",
      dataIndex: "key",
      width: "20%",
    },
    {
      title: "Sponsor Id",
      dataIndex: "Sponsor_Id",
      width: "20%",
    },
    {
      title: "Applied Date",
      dataIndex: "Applied_Date",
      width: "20%",
      render: (date: string) =>
        date
          ? new Date(date).toLocaleString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          : "N/A",
    },
    {
      title: language.application_status,
      dataIndex: "Status",
      render: (status: string, record: any) => {
        const statusMapping: Record<string, string> = {
          permanentReject: "Permanent reject",
          approvedUnsigned: "Approve Unsigned",
          reject: "Raised Query",
          pending: "Pending",
          resubmission: "Resubmission",
          draft: "Draft",
          approve: "Approved"
        };
        return <span
          style={{
            color: record?.appStatusLevel === "forwardToSponsorAterApproval" ? "#03a600ff" : status === "approved" ? "#03a600ff" : status === "pending" ? "#edc900ff" : status === "permanentReject" ? "red" : "black"
          }}
        >
          {record?.appStatusLevel === "forwardToSponsorAterApproval" ? "Aggreement Approved Next step Required" : statusMapping[status] || status}
        </span>;
      },
    },
  
    {
      title: "Action (Review)",
      dataIndex: "Name",
      width: "20%",
      render: (text: any, record: any) => (
 

        <div className="d-flex gap-2">

          <button className="btn btn-info"
            onClick={() => { handleRoute(record); }}
          >
           {record?.appStatusLevel === "forwardToSponsorAterApproval" ? 'Proceed to Next Step' : 'Preview'}
          </button>

  

          {/* Show View Certificate button only for approved status */}
          {record?.Status === "approved" && (
            <button
              className="btn btn-success"
              onClick={() => { handleViewCertificate(record) }}
            >
              <i className="bi bi-file-earmark-check me-1"></i>
              View Certificate
            </button>
          )}
        </div>

      ),
    }
  ]

 

  return (
    <>
      <div className="page-wrapper">
        <div>
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2 d-flex justify-content-between w-100">
                <div>
                  <h2 className="mb-1">My Agreement</h2>
                  <p style={{ fontSize: "1.25rem" }}>
                    Create and manage your agreement in one place. Start a new
                    agreement or track the progress of your existing ones
                  </p>
                </div>
                <div>
                  <button className="btn btn-info" onClick={handleRedirect}>
                    <i className="feather feather-plus-circle me-2"></i>
                    New Agreement
                  </button>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="card-body p-0">
                <div className="table-top-data">
                  <div className="row p-3">
                    <div className="col-sm-12 d-flex justify-content-end">
                       {/* <Select
                        className="mx-3 basic-single"
                        options={options2}
                        onChange={handleChangeForStatus}
                        defaultValue={appStatus?.label}
                        placeholder="Application Status"
                      /> */}
                      <Select
                        className="mx-3 basic-single"
                        options={options}
                        onChange={handleChange}
                        defaultValue={selectPending}
                        // placeholder="Select a flavor"
                      />
                      {/* <Input
                        placeholder="Search Application Id..."
                        style={{ width: 250 }}
                        allowClear
                      /> */}
                    </div>
                  </div>
                </div>

                <Table
                  className="table datanew dataTable no-footer"
                  // rowSelection={Selections ? rowSelection : undefined}
                  columns={columns}
                  rowHoverable={false}
                  rowKey={"Sponsor_Id"}
                  dataSource={tableData}
                  loading={loading}
                  pagination={{
                    locale: { items_per_page: "" },
                    nextIcon: <i className="ti ti-chevron-right" />,
                    prevIcon: <i className="ti ti-chevron-left" />,
                    defaultPageSize: 5,
                    showSizeChanger: true,
                    pageSizeOptions: ["5", "10", "20", "30"],
                    showTotal: (total, range) => `Showing ${range[0]} - ${range[1]} of ${total} entries`,
                  }}
           
                />
              </div>
            </div>
            {/* /Performance Indicator list */}
          </div>
          <ToastContainer />
        </div>
      </div>
    </>
  );
};

export default SponsorDashboard;
